/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// TEXT 1 STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	uniqueanswer: {
		display: 'block'
	},
	desc: {
		display: 'flex',
		height: pxToEm(30),
		margin: '0 auto',
		boxShadow: replacePXinStringWithEM('0 1px 2px 0 rgba(0,0,0,0.10), inset 0 -1px 2px 0 rgba(173,173,173,0.40)'),
		borderRadius: pxToEm(3),
		padding: replacePXinStringWithEM('0px 10px'),
		'& .background': {
			background: 'rgba(255,255,255,.9)',
			borderRadius: 'inherit',
			width: '100%',
			height: '100%',
			position: 'absolute',
			top: '0',
			left: '0',
			zIndex: '1'
		},
		'& .text': {
			// background: 'radial-gradient(ellipse at center, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 15%, rgba(255,255,255,0) 69%, rgba(255,255,255,0) 100%)',
			color: '#4A4A4A',
			alignSelf: 'center',
			position: 'relative',
			zIndex: '2',
			wordBreak: 'break-all'
		},
		'& .text.large': {
			fontSize: pxToEm(11),
			lineHeight: pxToEm(15)
		},
		'& .text.medium': {
			fontSize: pxToEm(13),
			lineHeight: pxToEm(16)
		},
		'& .text.standard': {
			fontSize: pxToEm(16),
			lineHeight: pxToEm(16)
		}
	}
};